/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * Represents the type of document stored in a bill record.
Maps to dimension.Bills.documentType (tinyint NULL).
NULL indicates the document type is unknown (e.g., bills created before this field existed).0 = Bill

1 = Receipt

2 = Vendor Credit


 */
export type BillDocumentType =
  (typeof BillDocumentType)[keyof typeof BillDocumentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BillDocumentType = {
  Bill: 0,
  Receipt: 1,
  VendorCredit: 2,
} as const;
